import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEdit, faTrashAlt,faChartLine, faEye,faExchangeAlt, faChartArea, faLink} 
       from "@fortawesome/free-solid-svg-icons";

import "./GridAction.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class GridAction extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  renderEdit(index) {
    return this.props.onEdit ? (
      <OverlayTrigger overlay={<Tooltip id="tip-top">Edit configuration</Tooltip>}>
      <span className="actButton" name="edit" index={index} onClick={this.props.onEdit}>
        <FontAwesomeIcon icon={faEdit} />
      </span>
      </OverlayTrigger>
    ) : null;
  }
  renderSwap(index) {
    return this.props.onSwap ? (
      <OverlayTrigger overlay={<Tooltip id="tip-top">Swap devices</Tooltip>}>
      <span className="actButton" name="edit" index={index} onClick={this.props.onSwap}>
        <FontAwesomeIcon icon={faExchangeAlt} />
      </span>
      </OverlayTrigger>
    ) : null;
  }
  renderEye(index) {
    return this.props.onDetail ? (
      <OverlayTrigger overlay={<Tooltip id="tip-top">Device reading details</Tooltip>}>
      <span className="actButton" name="detail" index={index} onClick={this.props.onDetail}>
        <FontAwesomeIcon icon={faEye} />
      </span>
      </OverlayTrigger>
    ) : null
  }
  renderChart(index) {
    return this.props.onChart ? (
      <OverlayTrigger overlay={<Tooltip id="tip-top">Chart readings</Tooltip>}>
      <span className="actButton" name="chart" index={index} onClick={this.props.onChart}>
        <FontAwesomeIcon icon={faChartLine} />
      </span>
      </OverlayTrigger>
    ) : null;
  }
  renderAltChart(index) {
    return this.props.altChart ? (
      <OverlayTrigger overlay={<Tooltip id="tip-top">Chart status</Tooltip>}>
      <span className="actButton" name="chart" index={index} onClick={this.props.altChart}>
        <FontAwesomeIcon icon={faChartArea} /> </span>
        </OverlayTrigger>
      ) : null
  }
  renderLinkChart(index) {
    return this.props.linkChart ? (
      <OverlayTrigger overlay={<Tooltip id="tip-top">Link Partners</Tooltip>}>
      <span className="actButton" name="chart" index={index} onClick={this.props.linkChart}>
        <FontAwesomeIcon icon={faLink} /> </span>
        </OverlayTrigger>
      ) : null
  }
  renderRemove(index) {
    return this.props.onRemove ? (
      <OverlayTrigger overlay={<Tooltip id="tip-top">Remove this device</Tooltip>}>
      <span className="actButton" name="remove" index={index} onClick={this.props.onRemove} >
        <FontAwesomeIcon icon={faTrashAlt} color="red" />
      </span>
      </OverlayTrigger>
    ) : null;
  }
  render() {
    const wrap = this.props?.wrap ?? ''
    return (
      <div className={"tour-action-buttons "+wrap} index={this.props.index}>
        {this.renderEye(this.props.index)}
        {this.renderChart(this.props.index)}
        {this.renderEdit(this.props.index)}
        {this.renderSwap(this.props.index)}
        {this.renderRemove(this.props.index)}
        {this.renderAltChart(this.props.index)}
        {this.renderLinkChart(this.props.index)}
      </div>
    );
  }
}

